import React from 'react';
import { BodyCell } from '@tableau/widgets-datagrid';
import { MetricUpdatedCellFormatter } from '../../../../metrics/components/MetricUpdatedCellFormatter';
import { StyledCellFormatter } from '../StyledCellWrapper';
import { ConnectedMetricValuePillWrapper } from '../../../../metrics/components/ConnectedMetricValuePill';

export function MetricValueCell(): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      function PlainTextCell(props: BodyCell.Props) {
        return <ConnectedMetricValuePillWrapper row={props.row}/>;
      }
  );
}

export function MetricUpdatedCell(): React.StatelessComponent<BodyCell.Props> {
  return MetricUpdatedCellFormatter();
}
